import { useEffect } from "react";
import { useMap, useMapsLibrary } from "@vis.gl/react-google-maps";

const GeoMarkProcessor = ({ markers }) => {
  const marker = useMapsLibrary("marker");
  const map = useMap();
  const markerObjects = [];

  useEffect(() => {
    if (!map || !marker) return;
    if (markers.length === 0) return;

    markers.forEach(({ lat, lng, title }, idx) => {
      const mark = new marker.Marker({
        position: { lat, lng },
        map: map,
        title: title,
        label: {
          text: `${title} dawdd awd wad awd awd`,
          color: "white",
          className: `bg-red-500 mb-10 p-2 rounded-lg`,
          optimized: true,
        },
      });
      mark.addListener("click", () => {
        alert(`${title} clicked`);
      })

      markerObjects.push(mark);
    });


    return () => {
      markerObjects.forEach((mark) => {
        mark.setMap(null);
      });
    };
  }, [map, marker, markers]);

  return null;
};

export default GeoMarkProcessor;
